import React, { useState, useEffect } from "react";
import Toggle from "../../common/Toggle/Toggle";
import Utility from "../../../common/utility";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import ApiCalls from "../../apis/api-calls";
import { inject, observer } from "mobx-react";
import config from "../../../config/config";
import { infoCircle } from "react-icons-kit/fa/infoCircle";
import { Icon } from "react-icons-kit";
import { ic_arrow_drop_down } from "react-icons-kit/md/ic_arrow_drop_down";
import { ic_close } from "react-icons-kit/md/ic_close";

const GenerateSubLicenseForm = inject("sharedStore", "profileStore")(
  observer(store => {
    const { triggerSubLicenseModal } = store;
    const [licData, setLicData] = useState({});
    const [modules, setModules] = useState([]);
    const [checkboxes, setCheckboxes] = useState({});
    const [parentCompanyId, setParentCompanyId] = useState("");
    const [subCompanies, setSubCompanies] = useState([]);
    const [toggle, setToggle] = useState("");
    const [toggleEnabled, setToggleEnabled] = useState("");
    const [clientName, setClientName] = useState("");
    const [createdDate, setCreatedDate] = useState("");
    const [subClientName, setSubClientName] = useState("");
    const [isSubClientNameValid, setIsSubClientNameValid] = useState(true);
    const [subClientNameError, setSubClientNameError] = useState("");
    const [startDate, setStartDate] = useState("");
    const [minStartDate, setMinStartDate] = useState("");
    const [maxStartDate, setMaxStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [minEndDate, setMinEndDate] = useState("");
    const [maxEndDate, setMaxEndDate] = useState("");
    const [isEndDateDisabled, setIsEndDateDisabled] = useState(true);
    const [license, setLicense] = useState("");
    const [tokenId, setTokenId] = useState("");
    const [licenseFips, setLicenseFips] = useState("");
    const [tokenIdFips, setTokenIdFips] = useState("");
    const [isStartDateValid, setIsStartDateValid] = useState(true);
    const [isEndDateValid, setIsEndDateValid] = useState(true);
    const [moduleError, setModuleError] = useState(false);
    const [invalidData, setInvalidData] = useState(false);
    const [licenseGenerated, setLicenseGenerated] = useState(false);
    const {
      sharedStore,
      sharedStore: { numberOfLicenses, fetchNumberOfLicenses }
    } = store;
    useEffect(() => {
      const { online, offline } = numberOfLicenses;
      if (online > 0 && offline === 0) {
        setToggle(true);
        setToggleEnabled(false);
      }
      if (online === 0 && offline > 0) {
        setToggle(false);
        setToggleEnabled(false);
      }
      if (online > 0 && offline > 0) {
        setToggle(true);
        setToggleEnabled(true);
      }
      const todaysDate = new Date().toISOString().split("T")[0];
      let vals = todaysDate.split("-");
      let created = vals[1] + "-" + vals[2] + "-" + vals[0];
      const oneMonthFromNow = moment(new Date())
        .add(1, "months")
        .toDate();
      setCreatedDate(created);
      setMinStartDate(new Date());
      setMaxStartDate(oneMonthFromNow);
      ApiCalls.getLicenseInfo()
        .then(res => {
          if (res.status_code === 200) {
            setLicData(res.data);
            let options = res.data.modules.map(({ name }) => {
              return name;
            });
            let checkboxes = options.reduce(
              (options, option, index) => ({
                ...options,
                [option]: res.data.modules[index].selected
              }),
              {}
            );
            setModules(res.data.modules);
            setClientName(res.data.client_name);
            setCheckboxes(checkboxes);
            setSubCompanies(res.data.subCompanies);
            setParentCompanyId(res.data.parent_client_id);
          } else {
            setLicData({});
          }
        })
        .catch(err => {
          setLicData({});
        });
    }, []);

    const handleToggle = () => {
      if (toggleEnabled) {
        setToggle(!toggle);
      }
    };

    const handleStartDate = date => {
      const selectedDate = moment(date).format();
      const oneDayFromNow = moment(selectedDate)
        .add(1, "days")
        .toDate();
      const oneYearFromNow = moment(selectedDate)
        .add(1, "years")
        .toDate();
      setStartDate(date);
      setMinEndDate(oneDayFromNow);
      setMaxEndDate(oneYearFromNow);
      setIsEndDateDisabled(false);
      setEndDate("");
      setInvalidData(false);
      setIsStartDateValid(true);
    };

    const handleEndDate = date => {
      setEndDate(date);
      setInvalidData(false);
      setIsEndDateValid(true);
    };

    const handleClose = () => {
      triggerSubLicenseModal();
    };

    const onCheckboxChange = e => {
      const { name } = e.target;
      setCheckboxes({ ...checkboxes, [name]: !checkboxes[name] });
      setInvalidData(false);
      setModuleError(false);
    };

    const validateAndGenerate = data => {
      let tracker = true;
      let atLeastOne = data.modules.every(i => i.selected === false);
      if (atLeastOne) {
        setModuleError(true);
        tracker = false;
      }
      if (data.start_date === "") {
        tracker = false;
        setIsStartDateValid(false);
      }
      if (data.end_date === "") {
        tracker = false;
        setIsEndDateValid(false);
      }
      const filteredValues = subCompanies.filter(
        x => x.companyName === subClientName
      );
      if (filteredValues.length > 0) {
        tracker = false;
        setIsSubClientNameValid(false);
        setSubClientNameError("Name is already in use by another license");
      }
      // No special characters allowed
      const REGEXP = /^[A-Za-z0-9 (),-.~:&_/'#+$!\\]*$/;
      if (!REGEXP.test(subClientName)) {
        tracker = false;
        setIsSubClientNameValid(false);
        setSubClientNameError(
          "Name cannot include: * % = ; ” < > ? [ ] ^ { } |"
        );
      }
      // Cannot be empty
      if (
        subClientName === "" ||
        subClientName.replace(/ +(?= )/g, "") === " "
      ) {
        tracker = false;
        setIsSubClientNameValid(false);
        setSubClientNameError("Field cannot be blank");
      }
      if (tracker) {
        sharedStore.showLoader();
        ApiCalls.generateSubLicense(data)
          .then(res => {
            sharedStore.hideLoader();
            if (res.status_code === 200) {
              setLicenseGenerated(true);
              setLicense(res.data.license_key);
              setTokenId(res.data.token);
              setLicenseFips(res.data.license_key_fips);
              setTokenIdFips(res.data.token_fips);
              setModuleError(false);
              setIsEndDateValid(true);
              setIsStartDateValid(true);
              setIsSubClientNameValid(true);
              setSubClientNameError("");
              fetchNumberOfLicenses({
                company_id: Utility.getData("companyId")
              });
              sharedStore.getLicenseData();
            }
            if (res.status_code === 400) {
              if (res.message === "SubClient Name Error") {
                setIsSubClientNameValid(false);
                setSubClientNameError(res.data.non_field_errors[0]);
                setInvalidData(true);
              }
            }
          })
          .catch(err => {
            sharedStore.hideLoader();
            console.log(err);
            setLicense("");
            setTokenId("");
            setLicenseFips("");
            setTokenIdFips("");
            setInvalidData(true);
          });
      } else {
        setInvalidData(true);
      }
    };

    const convertDate = date => {
      if (date instanceof Date) {
        return date.toISOString().split("T")[0];
      } else {
        return "";
      }
    };

    const generateSubLicense = () => {
      const keys = Object.keys(checkboxes);
      const values = Object.keys(checkboxes).map(i => checkboxes[i]);
      const modules = keys.map((i, index) => {
        return { name: i, selected: values[index] };
      });
      const data = {
        license_id: null,
        token: null,
        sub_client_name: subClientName,
        sub_company_id: null,
        parent_master_id: Utility.getData("companyId"),
        enable: true,
        license_mode: toggle,
        start_date: convertDate(startDate),
        end_date: convertDate(endDate),
        modules: modules,
        parent_client_id: parentCompanyId,
        client_name: clientName,
        email: Utility.getData("sharedStore")["membersData"][0].email
          ? Utility.getData("sharedStore")["membersData"][0].email
          : "r1@mailinator.com",
        fipsenabled: config.FIPSEnabled
      };
      validateAndGenerate(data);
    };

    const validateSubClientName = subClientName => {
      let tracker = true;
      // Name cannot be same
      const filteredValues = subCompanies.filter(
        x => x.companyName === subClientName
      );
      if (filteredValues.length > 0) {
        tracker = false;
        setIsSubClientNameValid(false);
        setSubClientNameError("Name is already in use by another license");
      }
      // No special characters allowed
      const REGEXP = /^[A-Za-z0-9 (),-.~:&_/'#+$!\\]*$/;
      if (!REGEXP.test(subClientName)) {
        tracker = false;
        setIsSubClientNameValid(false);
        setSubClientNameError(
          "Name cannot include: * % = ; ” < > ? [ ] ^ { } |"
        );
      }
      // Cannot be empty
      if (
        subClientName === "" ||
        subClientName.replace(/ +(?= )/g, "") === " "
      ) {
        tracker = false;
        setIsSubClientNameValid(false);
        setSubClientNameError("Field cannot be blank");
      }
      if (tracker) {
        setIsSubClientNameValid(true);
        setSubClientNameError("");
      }
    };
    const handleChange = e => {
      validateSubClientName(e.target.value);
      setSubClientName(e.target.value);
      setInvalidData(false);
    };

    const copyTxt = e => {
      debugger;
      let elem = e.target;
      for (; elem && elem !== document; elem = elem.parentNode) {
        if (elem.classList.contains("select_input")) {
          let keyvalue = elem.querySelector("input");
          let copytxt = elem.querySelector(".cpyTxt");
          keyvalue.select();
          document.execCommand("copy");
          copytxt.style.visibility = "visible";
          setTimeout(function() {
            copytxt.style.visibility = "hidden";
          }, 2000);
        }
      }
      return null;
    };

    return (
      <div className="sublin_popup cus_popupwrapper">
        <div className="sublin_popup_body">
          <div className="popheadtxt">
            Generate New Sub-client License{" "}
            <small className="sb_lic_total">
              {" "}
              ({numberOfLicenses.total} Remaining){" "}
            </small>
            <div className="lichead_wrapper">
              <span className="nw_title_txt">License Mode</span>
              <span className="pop_title_txt_nw">
                <span className="togglespan">
                  Offline{" "}
                  <Toggle
                    value={toggle}
                    onChange={handleToggle}
                    disabled={!toggleEnabled}
                  />{" "}
                  Online
                </span>
              </span>
              <span className="lic_close_icons">
                {" "}
                <Icon
                  className=""
                  size={30}
                  icon={ic_close}
                  onClick={handleClose}
                />
              </span>
            </div>
          </div>
          <div className="sublin_popupcontant">
            <div className="poptxt-wrap">
              <div className="poptxt-items">
                <span className="pop_title_name">Client Name</span>
                <span className="pop_title_txt">
                  <input
                    readOnly
                    type="text"
                    className="bg_gray"
                    value={clientName}
                  />
                </span>
              </div>
              <div className="poptxt-items">
                <span className="pop_title_name">Created</span>
                <span className="pop_title_txt">{createdDate}</span>
              </div>
            </div>
            <div className="poptxt-wrap">
              <div className="poptxt-items">
                <span className="pop_title_name">Sub Client Name</span>
                <span className="pop_title_txt">
                  <input
                    type="text"
                    onChange={e => handleChange(e)}
                    value={subClientName}
                    className={!isSubClientNameValid ? "error_input" : null}
                  />
                  {!isSubClientNameValid ? (
                    <p className="text_error">{subClientNameError}</p>
                  ) : null}
                </span>
              </div>
              <div className="poptxt-items">
                <span className="pop_title_name">Start Date (UTC)</span>
                <span className="pop_title_txt custom_date">
                  <DatePicker
                    selected={startDate}
                    dateFormat="MM/dd/yyyy"
                    onChange={date => handleStartDate(date)}
                    onKeyDown={e => e.preventDefault()}
                    minDate={minStartDate}
                    maxDate={maxStartDate}
                    className={!isStartDateValid ? "error_input" : null}
                    placeholderText="mm/dd/yyyy"
                  />
                  {!isStartDateValid ? (
                    <p className="text_error">Start date must be selected</p>
                  ) : null}
                </span>
              </div>
              <div className="poptxt-items">
                <span className="pop_title_name">End Dates (UTC)</span>
                <span className="pop_title_txt custom_date">
                  <DatePicker
                    selected={endDate}
                    dateFormat="MM/dd/yyyy"
                    onChange={date => handleEndDate(date)}
                    onKeyDown={e => e.preventDefault()}
                    minDate={minEndDate}
                    maxDate={maxEndDate}
                    className={!isEndDateValid ? "error_input" : null}
                    disabled={isEndDateDisabled}
                    placeholderText="mm/dd/yyyy"
                  />
                  {!isEndDateValid ? (
                    <p className="text_error">End date must be selected</p>
                  ) : null}
                </span>
              </div>
            </div>
            <div className="poptxt-wrap">
              <span className="pop_title_name">Module</span>
              <div className="lince_type_wrap">
                {modules.map(({ id, name, selected }) => {
                  return (
                    <div className="lince_type" key={id}>
                      <span className="form_custom_group">
                        <input
                          type="checkbox"
                          name={name}
                          id={name}
                          disabled={!selected}
                          checked={checkboxes[name]}
                          onChange={e => onCheckboxChange(e)}
                        />
                        <label for={name}>{name}</label>
                      </span>
                    </div>
                  );
                })}
                {moduleError && (
                  <p className="text_error">Must select at least one module</p>
                )}
              </div>
            </div>
            <div className="poptxt-wrap select_input">
              <span className="custom_info_text">
                <span className="info_help_text">
                  <Icon
                    className="info_down"
                    size={45}
                    icon={ic_arrow_drop_down}
                  />
                  Use this license key for Izenda versions 3.12 and below
                </span>
                <Icon
                  className="info_circle_icons"
                  size={20}
                  icon={infoCircle}
                />
              </span>
              <span className="pop_title_name">License Key - 128 bit</span>
              <input
                type="text"
                className="copyinput"
                value={license}
                disabled
              />
              <span
                onClick={e => {
                  copyTxt(e);
                  navigator.clipboard.writeText(license);
                }}
                className="btn_copy"
              >
                Copy
              </span>
              <span className="cpyTxt">Copied!</span>
            </div>
            <div className="poptxt-wrap select_input">
              <span className="custom_info_text">
                <span className="info_help_text">
                  <Icon
                    className="info_down"
                    size={45}
                    icon={ic_arrow_drop_down}
                  />
                  Use this license key for Izenda versions 4.0 and above
                </span>
                <Icon
                  className="info_circle_icons"
                  size={20}
                  icon={infoCircle}
                />
              </span>
              <span className="pop_title_name">License Key - 256 bit</span>
              <input
                type="text"
                className="copyinput"
                value={licenseFips}
                disabled
              />
              <span
                onClick={e => {
                  copyTxt(e);
                  navigator.clipboard.writeText(licenseFips);
                }}
                className="btn_copy"
              >
                Copy
              </span>
              <span className="cpyTxt">Copied!</span>
            </div>
            {!toggle ? (
              <div>
                <div className="poptxt-wrap select_input">
                  <span className="custom_info_text">
                    <span className="info_help_text">
                      <Icon
                        className="info_down"
                        size={45}
                        icon={ic_arrow_drop_down}
                      />
                      Use this token for Izenda versions 3.12 and below
                    </span>
                    <Icon
                      className="info_circle_icons"
                      size={20}
                      icon={infoCircle}
                    />
                  </span>
                  <span className="pop_title_name">Token - 128 bit</span>
                  <input
                    type="text"
                    className="copyinput"
                    value={tokenId}
                    disabled
                  />
                  <span
                    onClick={e => {
                      copyTxt(e);
                      navigator.clipboard.writeText(tokenId);
                    }}
                    className="btn_copy"
                  >
                    Copy
                  </span>
                  <span className="cpyTxt">Copied!</span>
                </div>
                <div className="poptxt-wrap select_input">
                  <span className="custom_info_text">
                    <span className="info_help_text">
                      <Icon
                        className="info_down"
                        size={45}
                        icon={ic_arrow_drop_down}
                      />
                      Use this token for Izenda versions 4.0 and above
                    </span>
                    <Icon
                      className="info_circle_icons"
                      size={20}
                      icon={infoCircle}
                    />
                  </span>
                  <span className="pop_title_name">Token - 256 bit</span>
                  <input
                    type="text"
                    className="copyinput"
                    value={tokenIdFips}
                    disabled
                  />
                  <span
                    onClick={e => {
                      copyTxt(e);
                      navigator.clipboard.writeText(tokenIdFips);
                    }}
                    className="btn_copy"
                  >
                    Copy
                  </span>
                  <span className="cpyTxt">Copied!</span>
                </div>
              </div>
            ) : null}

            <div className="actionbtn">
              {!licenseGenerated && (
                <span className="btn_copy" onClick={generateSubLicense}>
                  Generate
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  })
);

export default GenerateSubLicenseForm;



// WEBPACK FOOTER //
// ./src/components/Profile/LicenseComponent/GenerateSubLicenseForm.js